export default "__VITE_ASSET__CS5EWgN0__"